import { gql } from "@apollo/client";

export const GET_PENDING_DEPOSITS_COUNT = gql`
  {
    pendingDepositsCount
  }
`;